import { render } from "./TheShirts.vue?vue&type=template&id=a0478a5c&scoped=true"
import script from "./TheShirts.vue?vue&type=script&lang=js"
export * from "./TheShirts.vue?vue&type=script&lang=js"

import "./TheShirts.vue?vue&type=style&index=0&id=a0478a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0478a5c"]])

export default __exports__